// src/pages/ResetPasswordPage.js
import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { API } from '../services/api';
import './ResetPasswordPage.css';

const ResetPasswordPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  // Logo path - using the same logo as Header
  const PUBLIC_IMAGE_ROOT = process.env.PUBLIC_URL || '';
  const LOGO_PATH = `${PUBLIC_IMAGE_ROOT}/images2/Logos AWD/Horizontal/Colored_no_background.png`;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setStatus('error');
      setMessage('Passwords do not match.');
      return;
    }

    if (password.length < 6) {
      setStatus('error');
      setMessage('Password must be at least 6 characters long.');
      return;
    }

    setStatus('loading');
    setMessage('');

    try {
      const response = await API.post(`/auth/reset-password/${token}`, {
        password
      });

      if (response.data.success) {
        setStatus('success');
        setMessage('Password reset successfully!');

        // Save the new token
        if (response.data.token) {
          localStorage.setItem('authToken', response.data.token);
        }

        // Redirect to login after 2 seconds
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    } catch (error) {
      setStatus('error');
      setMessage(
        error.response?.data?.error ||
        'The link is invalid or has expired.'
      );
    }
  };

  return (
    <div className="reset-password-page">
      {/* Logo at top left */}
      <a href="https://www.automotive-database.com/" className="reset-password-logo-link">
        <img
          src={LOGO_PATH}
          alt="Automotive Database"
          className="reset-password-logo"
        />
      </a>

      <div className="reset-password-card">
        <h2 className="reset-password-title">
          New Password
        </h2>

        <p className="reset-password-description">
          Choose a new secure password.
        </p>

        {status === 'success' ? (
          <div className="reset-password-success">
            <div className="reset-password-success-icon">✓</div>
            <p className="reset-password-success-message">{message}</p>
            <p className="reset-password-success-redirect">
              Redirecting to login...
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="reset-password-form">
            {status === 'error' && (
              <div className="reset-password-error">
                {message}
              </div>
            )}

            <div className="reset-password-form-group">
              <label className="reset-password-label">
                New password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                placeholder="Min. 6 characters"
                className="reset-password-input"
              />
            </div>

            <div className="reset-password-form-group">
              <label className="reset-password-label">
                Confirm password
              </label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={6}
                placeholder="Retype your password"
                className="reset-password-input"
              />
            </div>

            <button
              type="submit"
              disabled={status === 'loading'}
              className="reset-password-button"
            >
              {status === 'loading' ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
        )}

        <div className="reset-password-back-link">
          <Link to="/login" className="reset-password-link">
            ← Back to login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;